import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import API from "../../services/API";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Collapse,
    Alert,
    Table,
} from "reactstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { Tag } from "antd";
import {
    Eye,
    Edit3,
    Trash2,
    Building2,
    Users,
    UserCheck,
    ShieldCheck,
    UploadCloud,
    AlertTriangle,
    Info,
    Plus,
    CheckCircle2,
} from "lucide-react";

const GOV_BLUE = "#0B4C9C";
const GOV_NAVY = "#07172F";
const GOV_GOLD = "#C8A24A";

const ClassesPage = () => {
    const [classes, setClasses] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const [updatedClassName, setUpdatedClassName] = useState("");
    const [selectedTeachers, setSelectedTeachers] = useState([]);
    const [newClassName, setNewClassName] = useState("");
    const [selectedForm, setSelectedForm] = useState(null);
    const [selectedSession, setSelectedSession] = useState(null);
    const [editSession, setEditSession] = useState(null);
    const [newTingkatan, setNewTingkatan] = useState("");
    const [newClassMoeis, setNewClassMoeis] = useState("");
    const [editTingkatan, setEditTingkatan] = useState("");
    const [editClassMoeis, setEditClassMoeis] = useState("");
    const [formFilter, setFormFilter] = useState(null);
    const [uniqueForms, setUniqueForms] = useState([]);
    const [incompleteClasses, setIncompleteClasses] = useState([]);
    const [currentIncompleteIndex, setCurrentIncompleteIndex] = useState(0);
    const [infoOpen, setInfoOpen] = useState(false);

    const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
    const [bulkData, setBulkData] = useState([]);
    const [bulkResults, setBulkResults] = useState(null);
    const [isProcessingBulk, setIsProcessingBulk] = useState(false);
    const [rawPasteData, setRawPasteData] = useState("");
    const [rawCheckResults, setRawCheckResults] = useState({});
    const [isCheckingNames, setIsCheckingNames] = useState(false);

    const [isGuruKelasModalOpen, setIsGuruKelasModalOpen] = useState(false);
    const [guruKelasClass, setGuruKelasClass] = useState(null);
    const [guruKelasOption, setGuruKelasOption] = useState(null);
    const [guruKelasLoading, setGuruKelasLoading] = useState(false);
    const [allTeacherEnabled, setAllTeacherEnabled] = useState(0);

    const navigate = useNavigate();

    const sessionOptions = [
        { value: 0, label: "Morning Session" },
        { value: 1, label: "Afternoon Session" },
    ];

    const forms = [
        {
            label: "Others / General Staff",
            value: "0",
        },
        {
            label: "Pre-Service / Intake",
            value: "9",
        },
        {
            label: "Special Unit",
            value: "7",
        },
        {
            label: "Transition Unit",
            value: "8",
        },
        ...Array.from({ length: 6 }, (_, index) => ({
            label: `Department Group ${index + 1}`,
            value: `${index + 1}`,
        })),
    ];

    const filteredClasses = formFilter
        ? classes.filter(
            (c) => String(c.tingkatan_moeis).toUpperCase().trim() === formFilter
        )
        : classes;

    useEffect(() => {
        if (incompleteClasses.length > 0) {
            const interval = setInterval(() => {
                setCurrentIncompleteIndex(
                    (prev) => (prev + 1) % incompleteClasses.length
                );
            }, 3000);

            return () => clearInterval(interval);
        }

        return undefined;
    }, [incompleteClasses]);

    const pageStyles = {
        shell: {
            minHeight: "100vh",
            padding: "28px",
            background:
                "radial-gradient(circle at top left, rgba(11, 76, 156, 0.10), transparent 28%), radial-gradient(circle at top right, rgba(7, 23, 47, 0.08), transparent 26%), linear-gradient(180deg, #f5f9ff 0%, #eef4fb 100%)",
            fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        },
        hero: {
            position: "relative",
            overflow: "hidden",
            marginBottom: 22,
            padding: 28,
            borderRadius: 28,
            color: "#fff",
            background:
                "linear-gradient(135deg, rgba(7, 23, 47, 0.98), rgba(11, 76, 156, 0.94))",
            boxShadow: "0 26px 70px rgba(8, 27, 58, 0.18)",
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) auto",
            gap: 24,
            alignItems: "center",
        },
        heroPattern: {
            position: "absolute",
            inset: 0,
            backgroundImage:
                "linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",
            backgroundSize: "44px 44px",
            pointerEvents: "none",
        },
        heroTitle: {
            position: "relative",
            zIndex: 2,
        },
        kicker: {
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 12,
            padding: "8px 12px",
            borderRadius: 999,
            border: "1px solid rgba(255,255,255,0.16)",
            background: "rgba(255,255,255,0.09)",
            color: "rgba(255,255,255,0.86)",
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
        },
        title: {
            margin: 0,
            fontSize: "clamp(30px, 4vw, 46px)",
            lineHeight: 1.05,
            fontWeight: 760,
            letterSpacing: "-0.03em",
        },
        subtitle: {
            maxWidth: 760,
            margin: "14px 0 0",
            color: "rgba(255,255,255,0.74)",
            fontSize: 14.5,
            lineHeight: 1.65,
            fontWeight: 400,
        },
        heroActions: {
            position: "relative",
            zIndex: 2,
            display: "flex",
            flexWrap: "wrap",
            gap: 10,
            justifyContent: "flex-end",
        },
        primaryButton: {
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            border: "none",
            borderRadius: 14,
            padding: "11px 16px",
            background: "#ffffff",
            color: GOV_NAVY,
            fontSize: 13,
            fontWeight: 700,
            boxShadow: "0 16px 36px rgba(0,0,0,0.16)",
        },
        ghostButton: {
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            border: "1px solid rgba(255,255,255,0.22)",
            borderRadius: 14,
            padding: "11px 16px",
            background: "rgba(255,255,255,0.10)",
            color: "#ffffff",
            fontSize: 13,
            fontWeight: 650,
        },
        statGrid: {
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: 14,
            marginBottom: 22,
        },
        statCard: {
            padding: 18,
            borderRadius: 22,
            background: "rgba(255,255,255,0.94)",
            border: "1px solid #dbeafe",
            boxShadow: "0 16px 42px rgba(8, 27, 58, 0.07)",
        },
        statLabel: {
            color: "#64748b",
            fontSize: 12,
            fontWeight: 600,
        },
        statValue: {
            marginTop: 7,
            color: GOV_NAVY,
            fontSize: 26,
            fontWeight: 750,
            letterSpacing: "-0.02em",
        },
        panel: {
            borderRadius: 26,
            background: "rgba(255,255,255,0.95)",
            border: "1px solid #dbeafe",
            boxShadow: "0 18px 48px rgba(8, 27, 58, 0.08)",
            overflow: "hidden",
        },
        panelHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
            padding: "22px 24px",
            borderBottom: "1px solid #e5edf7",
            background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
        },
        panelTitle: {
            margin: 0,
            color: GOV_NAVY,
            fontSize: 20,
            fontWeight: 700,
            letterSpacing: "-0.01em",
        },
        panelSubtitle: {
            margin: "5px 0 0",
            color: "#64748b",
            fontSize: 13,
            fontWeight: 400,
        },
        panelBody: {
            padding: 24,
        },
        filterBar: {
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            marginBottom: 18,
        },
        filterButton: (active) => ({
            border: active ? `1px solid ${GOV_BLUE}` : "1px solid #dbeafe",
            background: active ? GOV_BLUE : "#ffffff",
            color: active ? "#ffffff" : "#334155",
            borderRadius: 999,
            padding: "8px 13px",
            fontSize: 12,
            fontWeight: 600,
            boxShadow: active ? "0 10px 24px rgba(11,76,156,0.20)" : "none",
        }),
        warningBox: {
            marginBottom: 18,
            padding: 18,
            borderRadius: 22,
            background: "linear-gradient(135deg, #fff7ed, #fffbeb)",
            border: "1px solid #fed7aa",
            color: "#7c2d12",
            boxShadow: "0 14px 34px rgba(120, 53, 15, 0.08)",
        },
        warningBadge: {
            width: 54,
            height: 54,
            borderRadius: 18,
            display: "grid",
            placeItems: "center",
            background: "#ffffff",
            color: "#9a3412",
            fontWeight: 800,
            fontSize: 24,
            boxShadow: "0 10px 24px rgba(120, 53, 15, 0.13)",
        },
    };

    const selectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: 44,
            borderRadius: 14,
            borderColor: state.isFocused ? GOV_BLUE : "#dbeafe",
            boxShadow: state.isFocused ? "0 0 0 4px rgba(11,76,156,0.10)" : "none",
            "&:hover": {
                borderColor: GOV_BLUE,
            },
        }),
        multiValue: (base) => ({
            ...base,
            borderRadius: 999,
            background: "#eef6ff",
            color: GOV_BLUE,
        }),
        option: (base, state) => ({
            ...base,
            background: state.isSelected
                ? GOV_BLUE
                : state.isFocused
                    ? "#eef6ff"
                    : "#ffffff",
            color: state.isSelected ? "#ffffff" : "#0f172a",
        }),
    };

    const tableStyles = {
        table: {
            style: {
                borderRadius: "22px",
                overflow: "hidden",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#f5f9ff",
                borderBottomColor: "#dbeafe",
                minHeight: "58px",
            },
        },
        headCells: {
            style: {
                color: GOV_BLUE,
                fontSize: "12px",
                fontWeight: 700,
                letterSpacing: "0.03em",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "72px",
                borderBottomColor: "#eef2f7",
                fontSize: "14px",
                color: "#0f172a",
            },
            highlightOnHoverStyle: {
                backgroundColor: "#eff6ff",
            },
        },
    };

    const fetchClasses = () => {
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            token: localStorage.getItem("token"),
        };

        API.get("/portal/getClasses", { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    const fetchedClasses = response.data.data;
                    setClasses(fetchedClasses);

                    const formsFromAPI = Array.from(
                        new Set(
                            fetchedClasses.map((c) => c.tingkatan_moeis?.toUpperCase().trim())
                        )
                    ).filter(Boolean);

                    const missing = fetchedClasses.filter(
                        (c) => !c.tingkatan_moeis || !c.class_moeis_format
                    );

                    setIncompleteClasses(missing);
                    setUniqueForms(formsFromAPI);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error fetching department records", { autoClose: 5000 });
            });
    };

    const fetchTeachers = () => {
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            token: localStorage.getItem("token"),
        };

        API.get("/portal/getTeachers", { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    const teacherOptions = response.data.data.map((teacher) => ({
                        label: teacher.full_name,
                        value: teacher.teacher_uuid,
                    }));

                    setTeachers(teacherOptions);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error fetching officer records", { autoClose: 5000 });
            });
    };

    useEffect(() => {
        fetchClasses();
        fetchTeachers();
    }, []);

    const openGuruKelasModal = (classRow) => {
        setGuruKelasClass(classRow);
        setGuruKelasOption(null);
        setIsGuruKelasModalOpen(true);
    };

    const closeGuruKelasModal = () => {
        setIsGuruKelasModalOpen(false);
        setGuruKelasClass(null);
        setGuruKelasOption(null);
    };

    const handleSetGuruKelas = async () => {
        if (!guruKelasOption) {
            toast.error("Please select an officer", { autoClose: 3000 });
            return;
        }

        setGuruKelasLoading(true);

        try {
            const headers = { token: localStorage.getItem("token") };
            const payload = {
                class_id: guruKelasClass.class_id,
                teacher_uuid: guruKelasOption.value,
            };

            const res = await API.post("/portal/setGuruKelas", payload, { headers });

            if (res.data.response_code === 1000) {
                toast.success("Department lead assigned.", { autoClose: 3000 });
                closeGuruKelasModal();
                fetchClasses();
            } else {
                toast.error(res.data.message, { autoClose: 3000 });
            }
        } catch (e) {
            toast.error("Server error", { autoClose: 3000 });
        } finally {
            setGuruKelasLoading(false);
        }
    };

    const handleUnsetGuruKelas = async (classRow) => {
        setGuruKelasLoading(true);

        try {
            const headers = { token: localStorage.getItem("token") };
            const payload = { class_id: classRow.class_id };

            const res = await API.post("/portal/unsetGuruKelas", payload, {
                headers,
            });

            if (res.data.response_code === 1000) {
                toast.success("Department lead removed.", { autoClose: 3000 });
                fetchClasses();
            } else {
                toast.error(res.data.message, { autoClose: 3000 });
            }
        } catch (e) {
            toast.error("Server error", { autoClose: 3000 });
        } finally {
            setGuruKelasLoading(false);
        }
    };

    const openEditModal = (classData) => {
        setSelectedClass(classData);
        setUpdatedClassName(classData.class_name);
        setSelectedTeachers(
            classData.teachers.map((teacher) => ({
                label: teacher.teacher_name,
                value: teacher.teacher_uuid,
            }))
        );
        setAllTeacherEnabled(classData.all_teacher_enabled ?? 0);

        const sessionOption = sessionOptions.find(
            (opt) => opt.value === classData.session
        );

        setEditSession(sessionOption || null);
        setEditTingkatan(classData.tingkatan_moeis || "");
        setEditClassMoeis(classData.class_moeis_format || "");
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setSelectedClass(null);
        setIsEditModalOpen(false);
    };

    const openAddModal = () => {
        setNewClassName("");
        setSelectedTeachers([]);
        setSelectedForm(null);
        setSelectedSession(null);
        setNewTingkatan("");
        setNewClassMoeis("");
        setIsAddModalOpen(true);
    };

    const closeAddModal = () => {
        setIsAddModalOpen(false);
    };

    const openDeleteModal = (classData) => {
        setSelectedClass(classData);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setSelectedClass(null);
        setIsDeleteModalOpen(false);
    };

    const handleAddClass = () => {
        if (!newClassName) {
            toast.error("Department name cannot be empty", { autoClose: 5000 });
            return;
        }

        if (!selectedForm) {
            toast.error("Please select a department group", { autoClose: 5000 });
            return;
        }

        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            token: localStorage.getItem("token"),
        };

        API.post(
            "/portal/addClass",
            {
                class_name: newClassName,
                form: selectedForm.value,
                session: 0,
                tingkatan_moeis: newTingkatan || null,
                class_moeis: newClassMoeis || null,
            },
            { headers }
        )
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Department added successfully", { autoClose: 5000 });
                    closeAddModal();
                    fetchClasses();
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error adding department", { autoClose: 5000 });
            });
    };

    const handleDeleteClass = () => {
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            token: localStorage.getItem("token"),
        };

        API.post(
            "/portal/deleteClass",
            {
                class_id: selectedClass.class_id,
            },
            { headers }
        )
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Department deleted successfully", { autoClose: 5000 });
                    closeDeleteModal();
                    fetchClasses();
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error deleting department", { autoClose: 5000 });
            });
    };

    const handleSaveChanges = () => {
        if (!updatedClassName) {
            toast.error("Department name cannot be empty", { autoClose: 5000 });
            return;
        }
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            token: localStorage.getItem("token"),
        };

        const teacherUUIDs = selectedTeachers.map((teacher) => teacher.value);

        API.post(
            "/portal/updateTeachersForClass",
            {
                class_id: selectedClass.class_id,
                class_name: updatedClassName,
                teacher_uuids: teacherUUIDs,
                session: 0,
                tingkatan_moeis: editTingkatan || null,
                class_moeis: editClassMoeis || null,
                all_teacher_enabled: allTeacherEnabled,
            },
            { headers }
        )
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Department updated successfully", { autoClose: 5000 });
                    closeEditModal();
                    fetchClasses();
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error updating department", { autoClose: 5000 });
            });
    };

    const handleRawPasteChange = (e) => {
        const text = e.target.value;
        setRawPasteData(text);

        const rows = text.split("\n").filter((row) => row.trim() !== "");

        const parsed = rows
            .map((row) => {
                const cols = row.includes("\t") ? row.split("\t") : row.split(",");

                const rawMoeisName = (cols[0] || "").trim();
                const inputClassName = (cols[1] || "").trim();

                const matchedClass = classes.find(
                    (c) => c.class_name.toLowerCase() === inputClassName.toLowerCase()
                );

                return {
                    moeis_name: rawMoeisName,
                    new_class_name: inputClassName,
                    class_id: matchedClass ? matchedClass.class_id : null,
                };
            })
            .filter((item) => item.moeis_name);

        setBulkData(parsed);
    };

    useEffect(() => {
        const namesToCheck = bulkData
            .map((d) => d.moeis_name)
            .filter((n) => n && n.trim().length > 0);

        if (namesToCheck.length === 0) {
            setRawCheckResults({});
            return;
        }

        const delayDebounceFn = setTimeout(async () => {
            setIsCheckingNames(true);

            try {
                const token = localStorage.getItem("token");
                const response = await API.post(
                    "/student/bulkCheckByMoeisName",
                    { names: namesToCheck },
                    { headers: { token } }
                );

                if (response.data.response_code === 1000) {
                    const foundMap = {};

                    response.data.data.found.forEach((student) => {
                        foundMap[student.moeis_name.trim().toUpperCase()] = student;
                    });

                    const notFoundSet = new Set(
                        (response.data.data.not_found || []).map((name) =>
                            name.trim().toUpperCase()
                        )
                    );

                    setRawCheckResults({ foundMap, notFoundSet });
                } else {
                    console.error("API error:", response.data.message);
                }
            } catch (err) {
                console.error("Network error during check:", err);
            } finally {
                setIsCheckingNames(false);
            }
        }, 1000);

        return () => clearTimeout(delayDebounceFn);
    }, [bulkData]);

    const closeBulkModal = () => {
        setIsBulkModalOpen(false);
        setBulkData([]);
        setBulkResults(null);
        setRawPasteData("");
        setRawCheckResults({});
    };

    const handleExecuteBulkAction = async () => {
        setIsProcessingBulk(true);
        const headers = { token: localStorage.getItem("token") };

        const studentsToMove = [];
        const studentsToRegister = [];

        bulkData.forEach((d) => {
            const lookupKey = d.moeis_name.trim().toUpperCase();
            const isFound = rawCheckResults.foundMap?.[lookupKey];

            if (isFound) {
                studentsToMove.push({
                    moeis_name: isFound.moeis_name,
                    student_uuid: isFound.student_uuid,
                    old_class_id: isFound.class_id,
                    old_class_name: isFound.class_name,
                    new_class_id: d.class_id,
                    new_class_name: d.new_class_name,
                });
            } else {
                studentsToRegister.push({
                    first_name: d.moeis_name,
                    moeis_name: d.moeis_name,
                    class_id: d.class_id,
                    new_class_name: d.new_class_name,
                });
            }
        });

        try {
            if (studentsToRegister.length > 0) {
                const regRes = await API.post(
                    "/student/registerStudentByAdminPortal",
                    { students: studentsToRegister },
                    { headers }
                );

                if (regRes.data.response_code !== 1000) {
                    toast.error(`Registration failed: ${regRes.data.message}`);
                    setIsProcessingBulk(false);
                    return;
                }
            }

            if (studentsToMove.length > 0) {
                const moveRes = await API.post(
                    "/student/bulkMoveStudentsByMoeis",
                    { students: studentsToMove },
                    { headers }
                );

                if (moveRes.data.response_code === 1000) {
                    setBulkResults(moveRes.data.data);
                } else {
                    toast.error(`Transfer failed: ${moveRes.data.message}`);
                }
            }

            toast.success(
                `Success: ${studentsToRegister.length} registered, ${studentsToMove.length} transferred`
            );

            fetchClasses();

            if (studentsToMove.length === 0) closeBulkModal();
        } catch (error) {
            toast.error("Bulk update failed");
            console.error(error);
        } finally {
            setIsProcessingBulk(false);
        }
    };

    const columns = [
        {
            name: "DEPARTMENT / UNIT",
            grow: 1.3,
            sortable: true,
            selector: (row) => row.class_name,
            cell: (row) => (
                <div style={{ padding: "14px 0" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <div
                            style={{
                                width: 36,
                                height: 36,
                                flex: "0 0 36px",
                                borderRadius: 12,
                                display: "grid",
                                placeItems: "center",
                                background: "#eef6ff",
                                color: GOV_BLUE,
                            }}
                        >
                            <Building2 size={18} />
                        </div>

                        <div>
                            <div
                                style={{
                                    fontWeight: 700,
                                    color: GOV_NAVY,
                                    fontSize: 14,
                                    letterSpacing: "-0.01em",
                                }}
                            >
                                {row.class_name}
                            </div>

                            {row.class_moeis_format && (
                                <div
                                    style={{
                                        fontSize: 11,
                                        color: "#64748b",
                                        fontWeight: 500,
                                        marginTop: 3,
                                    }}
                                >
                                    Official format: {row.class_moeis_format}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ),
        },
        {
            name: "ASSIGNED OFFICERS",
            grow: 2.6,
            cell: (row) => (
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 7,
                        padding: "12px 0",
                    }}
                >
                    {row.all_teacher_enabled === 1 ? (
                        <div
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 7,
                                padding: "7px 13px",
                                background: "#ecfdf5",
                                border: "1px solid #a7f3d0",
                                borderRadius: 999,
                                fontSize: 12,
                                fontWeight: 650,
                                color: "#047857",
                            }}
                        >
                            <CheckCircle2 size={14} />
                            All officers enabled
                        </div>
                    ) : row.teachers.length > 0 ? (
                        row.teachers.map((teacher, index) => (
                            <div
                                key={teacher.teacher_uuid || index}
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 7,
                                    padding: "7px 12px",
                                    background: "#ffffff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: 999,
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                                }}
                            >
                                <UserCheck size={13} color={GOV_BLUE} />
                                <span
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 500,
                                        color: "#374151",
                                    }}
                                >
                                    {teacher.teacher_name}
                                </span>
                            </div>
                        ))
                    ) : (
                        <span
                            style={{
                                color: "#94a3b8",
                                fontSize: 12,
                                fontStyle: "italic",
                            }}
                        >
                            No officers assigned
                        </span>
                    )}
                </div>
            ),
        },
        {
            name: "DEPARTMENT LEAD",
            grow: 1.4,
            cell: (row) => (
                <div
                    style={{
                        background: row.class_teacher_name ? "#eef6ff" : "#f8fafc",
                        border: `1px solid ${row.class_teacher_name ? "#bfdbfe" : "#e5e7eb"
                            }`,
                        borderRadius: 14,
                        padding: 12,
                        width: "100%",
                        textAlign: "left",
                    }}
                >
                    {row.class_teacher_name ? (
                        <>
                            <div
                                style={{
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: GOV_BLUE,
                                    marginBottom: 4,
                                }}
                            >
                                Department Lead
                            </div>
                            <div
                                style={{
                                    fontSize: 13,
                                    fontWeight: 650,
                                    color: GOV_NAVY,
                                }}
                            >
                                {row.class_teacher_name}
                            </div>
                            <div style={{ display: "flex", gap: 12, marginTop: 9 }}>
                                <button
                                    onClick={() => openGuruKelasModal(row)}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        color: GOV_BLUE,
                                        fontSize: 12,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        padding: 0,
                                    }}
                                >
                                    Change
                                </button>
                                <button
                                    onClick={() => handleUnsetGuruKelas(row)}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        color: "#64748b",
                                        fontSize: 12,
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        padding: 0,
                                    }}
                                >
                                    Remove
                                </button>
                            </div>
                        </>
                    ) : (
                        <button
                            onClick={() => openGuruKelasModal(row)}
                            style={{
                                background: "none",
                                border: "none",
                                color: GOV_BLUE,
                                fontSize: 13,
                                fontWeight: 650,
                                cursor: "pointer",
                                padding: 0,
                            }}
                        >
                            + Assign Lead
                        </button>
                    )}
                </div>
            ),
        },
        {
            name: "ACTIONS",
            width: "150px",
            right: true,
            cell: (row) => (
                <div style={{ display: "flex", gap: 8 }}>
                    <button
                        title="View"
                        onClick={() => navigate(`/class-details/${row.class_id}`)}
                        style={{
                            padding: 9,
                            background: "#ffffff",
                            border: "1px solid #dbeafe",
                            borderRadius: 10,
                            cursor: "pointer",
                            color: GOV_BLUE,
                        }}
                    >
                        <Eye size={16} />
                    </button>
                    <button
                        title="Edit"
                        onClick={() => openEditModal(row)}
                        style={{
                            padding: 9,
                            background: GOV_BLUE,
                            border: "none",
                            borderRadius: 10,
                            cursor: "pointer",
                            color: "#ffffff",
                        }}
                    >
                        <Edit3 size={16} />
                    </button>
                    <button
                        title="Delete"
                        onClick={() => openDeleteModal(row)}
                        style={{
                            padding: 9,
                            background: "#ffffff",
                            border: "1px solid #fee2e2",
                            borderRadius: 10,
                            cursor: "pointer",
                            color: "#dc2626",
                        }}
                    >
                        <Trash2 size={16} />
                    </button>
                </div>
            ),
        },
    ];
    const modalStyles = (
        <style>{`
    .spgov-modal .modal-content {
      border: 0;
      border-radius: 26px;
      overflow: hidden;
      box-shadow: 0 30px 90px rgba(8, 27, 58, 0.22);
      background: #ffffff;
    }

    .spgov-modal .modal-header {
      padding: 22px 24px;
      border-bottom: 1px solid #e5edf7;
      background:
        radial-gradient(circle at top right, rgba(11, 76, 156, 0.10), transparent 34%),
        linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    }

    .spgov-modal .modal-title {
      color: #07172f;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: -0.01em;
    }

    .spgov-modal .btn-close {
      width: 34px;
      height: 34px;
      border-radius: 12px;
      background-color: #eef6ff;
      opacity: 1;
      background-size: 12px;
    }

    .spgov-modal .modal-body {
      padding: 24px;
      background: #ffffff;
    }

    .spgov-modal .modal-footer {
      padding: 18px 24px;
      border-top: 1px solid #e5edf7;
      background: #f8fbff;
    }

    .spgov-modal label {
      display: block;
      margin-bottom: 7px;
      color: #24364f;
      font-size: 13px;
      font-weight: 650;
    }

    .spgov-modal .form-control {
      min-height: 44px;
      border-radius: 14px;
      border: 1px solid #dbeafe;
      color: #0f172a;
      font-size: 14px;
      font-weight: 400;
      box-shadow: none;
    }

    .spgov-modal .form-control:focus {
      border-color: #0b4c9c;
      box-shadow: 0 0 0 4px rgba(11, 76, 156, 0.10);
    }

    .spgov-modal-section {
      padding: 16px;
      border-radius: 18px;
      border: 1px solid #e5edf7;
      background: #f8fbff;
      margin-bottom: 16px;
    }

    .spgov-modal-section-title {
      display: flex;
      align-items: center;
      gap: 9px;
      margin-bottom: 14px;
      color: #07172f;
      font-size: 14px;
      font-weight: 700;
    }

    .spgov-modal-section-title svg {
      color: #0b4c9c;
    }

    .spgov-modal-help {
      margin-top: 7px;
      color: #64748b;
      font-size: 12px;
      line-height: 1.45;
    }

    .spgov-modal-footer-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
      width: 100%;
    }

    .spgov-btn-primary {
      min-height: 42px;
      border: 0 !important;
      border-radius: 14px !important;
      padding: 0 18px !important;
      background: #0b4c9c !important;
      color: #ffffff !important;
      font-size: 13px !important;
      font-weight: 650 !important;
      box-shadow: 0 12px 26px rgba(11, 76, 156, 0.22);
    }

    .spgov-btn-primary:hover {
      background: #083f83 !important;
    }

    .spgov-btn-secondary {
      min-height: 42px;
      border-radius: 14px !important;
      padding: 0 18px !important;
      border: 1px solid #dbeafe !important;
      background: #ffffff !important;
      color: #475569 !important;
      font-size: 13px !important;
      font-weight: 600 !important;
    }

    .spgov-btn-danger {
      min-height: 42px;
      border: 0 !important;
      border-radius: 14px !important;
      padding: 0 18px !important;
      background: #dc2626 !important;
      color: #ffffff !important;
      font-size: 13px !important;
      font-weight: 650 !important;
      box-shadow: 0 12px 26px rgba(220, 38, 38, 0.18);
    }

    .spgov-delete-card {
      padding: 18px;
      border-radius: 20px;
      border: 1px solid #fecaca;
      background: #fef2f2;
      color: #7f1d1d;
      line-height: 1.6;
    }

    .spgov-delete-card strong {
      color: #991b1b;
    }

    .spgov-bulk-alert {
      padding: 16px;
      border-radius: 18px;
      border: 1px solid #bfdbfe;
      background: #eef6ff;
      color: #1e3a8a;
      line-height: 1.55;
      margin-bottom: 16px;
    }

    .spgov-bulk-alert code {
      background: #ffffff;
      border: 1px solid #dbeafe;
      border-radius: 8px;
      padding: 2px 7px;
      color: #0b4c9c;
      font-size: 12px;
    }

    .spgov-modal-table-wrap {
      max-height: 350px;
      overflow: auto;
      border-radius: 18px;
      border: 1px solid #e5e7eb;
    }

    .spgov-modal-table-wrap table {
      margin-bottom: 0;
    }

    .spgov-modal-table-wrap thead th {
      background: #f5f9ff !important;
      color: #0b4c9c;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.03em;
      text-transform: uppercase;
      border-bottom: 1px solid #dbeafe;
    }

    .spgov-modal-table-wrap td {
      font-size: 13px;
      vertical-align: middle;
    }

    .spgov-success-state {
      text-align: center;
      padding: 28px 18px;
    }

    .spgov-success-icon {
      width: 58px;
      height: 58px;
      border-radius: 20px;
      display: grid;
      place-items: center;
      margin: 0 auto 14px;
      background: #dcfce7;
      color: #16a34a;
    }

    @media (max-width: 576px) {
      .spgov-modal .modal-body {
        padding: 18px;
      }

      .spgov-modal .modal-header,
      .spgov-modal .modal-footer {
        padding-left: 18px;
        padding-right: 18px;
      }

      .spgov-modal-footer-actions {
        flex-direction: column-reverse;
      }

      .spgov-modal-footer-actions .btn {
        width: 100%;
      }
    }
  `}</style>
    );

    return (
        <Fragment>
            {modalStyles}
            <div style={pageStyles.shell}>
                <div style={pageStyles.hero}>
                    <div style={pageStyles.heroPattern} />

                    <div style={pageStyles.heroTitle}>
                        <div style={pageStyles.kicker}>
                            <ShieldCheck size={14} />
                            SPGO.my Department Administration
                        </div>

                        <h1 style={pageStyles.title}>Department Management</h1>

                        <p style={pageStyles.subtitle}>
                            Manage departments, assigned officers, department leads, official
                            record formats, sessions and personnel movement from one
                            administrative workspace.
                        </p>
                    </div>

                    <div style={pageStyles.heroActions}>
                        <button
                            type="button"
                            style={pageStyles.ghostButton}
                            onClick={() => setIsBulkModalOpen(true)}
                        >
                            <UploadCloud size={16} />
                            Bulk Personnel Update
                        </button>

                        <button type="button" style={pageStyles.primaryButton} onClick={openAddModal}>
                            <Plus size={16} />
                            Add Department
                        </button>
                    </div>
                </div>


                {incompleteClasses.length > 0 && (
                    <div style={pageStyles.warningBox}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 18,
                                flexWrap: "wrap",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                                <div style={pageStyles.warningBadge}>
                                    {incompleteClasses.length}
                                </div>

                                <div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            fontWeight: 700,
                                            color: "#7c2d12",
                                        }}
                                    >
                                        <AlertTriangle size={17} />
                                        Action required
                                    </div>

                                    <div style={{ marginTop: 4, color: "#9a3412" }}>
                                        {incompleteClasses.length > 1
                                            ? "Departments are"
                                            : "Department is"}{" "}
                                        missing official integration information. Update the record
                                        to avoid reporting or sync issues.
                                    </div>
                                </div>
                            </div>

                            <button
                                className="btn btn-dark btn-sm"
                                onClick={() => {
                                    const currentClass =
                                        incompleteClasses[currentIncompleteIndex];
                                    if (currentClass) openEditModal(currentClass);
                                }}
                            >
                                Fix Now
                            </button>
                        </div>
                    </div>
                )}

                <div style={pageStyles.panel}>
                    <div style={pageStyles.panelHeader}>
                        <div>
                            <h5 style={pageStyles.panelTitle}>Department Directory</h5>
                            <p style={pageStyles.panelSubtitle}>
                                View, filter and manage departments, officers and department
                                leads.
                            </p>
                        </div>

                        <button
                            type="button"
                            className="btn btn-primary"
                            style={{
                                borderRadius: 14,
                                background: GOV_BLUE,
                                borderColor: GOV_BLUE,
                                fontWeight: 650,
                            }}
                            onClick={openAddModal}
                        >
                            <Plus size={16} className="me-1" />
                            Add Department
                        </button>
                    </div>

                    <div style={pageStyles.panelBody}>
                        <div style={pageStyles.filterBar}>
                            <button
                                style={pageStyles.filterButton(formFilter === null)}
                                onClick={() => setFormFilter(null)}
                            >
                                All
                            </button>

                            {uniqueForms.map((form) => (
                                <button
                                    key={form}
                                    style={pageStyles.filterButton(formFilter === form)}
                                    onClick={() => setFormFilter(form)}
                                >
                                    {form}
                                </button>
                            ))}
                        </div>

                        <DataTable
                            columns={columns}
                            data={filteredClasses}
                            striped={false}
                            center={false}
                            responsive
                            persistTableHead
                            highlightOnHover
                            customStyles={tableStyles}
                        />
                    </div>
                </div>
            </div>
            <Modal
                isOpen={isBulkModalOpen}
                toggle={closeBulkModal}
                size="lg"
                modalClassName="spgov-modal"
            >
                <ModalHeader toggle={closeBulkModal}>
                    Bulk Personnel Department Update
                </ModalHeader>

                <ModalBody>
                    {!bulkResults ? (
                        <>
                            <div className="spgov-bulk-alert">
                                <strong>Upload format</strong>
                                <br />
                                Paste records from Excel or Google Sheets using this format:{" "}
                                <code>Personnel Name [Tab/Comma] Department Name</code>
                            </div>

                            <div className="spgov-modal-section">
                                <div className="spgov-modal-section-title">
                                    <UploadCloud size={16} />
                                    Paste Personnel Records
                                </div>

                                <textarea
                                    className="form-control"
                                    rows="8"
                                    placeholder={"Example:\nAHMAD BIN ALI, FINANCE UNIT"}
                                    value={rawPasteData}
                                    onChange={handleRawPasteChange}
                                    style={{
                                        fontFamily:
                                            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace',
                                        fontSize: 13,
                                    }}
                                />

                                <div className="spgov-modal-help">
                                    Existing personnel will be transferred. New or unmatched personnel
                                    will be prepared for registration.
                                </div>
                            </div>

                            {bulkData.length > 0 && (
                                <div className="spgov-modal-section">
                                    <div className="spgov-modal-section-title">
                                        <CheckCircle2 size={16} />
                                        Preview & Validation ({bulkData.length} rows)
                                        {isCheckingNames && (
                                            <span className="spinner-border spinner-border-sm text-primary ms-2" />
                                        )}
                                    </div>

                                    <div className="spgov-modal-table-wrap">
                                        <Table size="sm" hover striped>
                                            <thead>
                                                <tr>
                                                    <th>Personnel Name</th>
                                                    <th>Current Department</th>
                                                    <th>Target Department</th>
                                                    <th className="text-center">Status</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {bulkData.map((d, i) => {
                                                    const lookupKey = d.moeis_name.trim().toUpperCase();
                                                    const isFound = rawCheckResults.foundMap?.[lookupKey];
                                                    const isNotFound = rawCheckResults.notFoundSet?.has(lookupKey);

                                                    return (
                                                        <tr key={i}>
                                                            <td className={isNotFound ? "text-danger fw-bold" : ""}>
                                                                {d.moeis_name}
                                                            </td>

                                                            <td>
                                                                {isFound ? (
                                                                    <>
                                                                        <span className="fw-bold">{isFound.class_name}</span>
                                                                        <br />
                                                                        <span style={{ fontSize: 11, color: "#64748b" }}>
                                                                            {isFound.class_id}
                                                                        </span>
                                                                    </>
                                                                ) : (
                                                                    <span className="text-muted">-</span>
                                                                )}
                                                            </td>

                                                            <td className={!d.class_id ? "text-danger fw-bold" : ""}>
                                                                {d.new_class_name || "Missing"}
                                                            </td>

                                                            <td className="text-center">
                                                                <div className="d-flex flex-wrap justify-content-center gap-1">
                                                                    {d.class_id ? (
                                                                        <Tag color="blue">Department OK</Tag>
                                                                    ) : (
                                                                        <Tag color="volcano">Wrong Department</Tag>
                                                                    )}

                                                                    {isCheckingNames ? (
                                                                        <Tag color="processing">Checking...</Tag>
                                                                    ) : isFound ? (
                                                                        <Tag color="green">Personnel OK</Tag>
                                                                    ) : (
                                                                        <Tag color="red">New / Unmatched</Tag>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="spgov-success-state">
                            <div className="spgov-success-icon">
                                <CheckCircle2 size={30} />
                            </div>
                            <h5 className="mb-1">Bulk update completed</h5>
                            <p className="text-muted mb-0">
                                The operation has been processed successfully.
                            </p>
                        </div>
                    )}
                </ModalBody>

                <ModalFooter>
                    {!bulkResults ? (
                        <div className="d-flex justify-content-between w-100 flex-wrap gap-2">
                            <Button
                                color="link"
                                className="text-danger"
                                onClick={() => {
                                    setRawPasteData("");
                                    setBulkData([]);
                                    setRawCheckResults({});
                                }}
                            >
                                Clear All
                            </Button>

                            <div className="spgov-modal-footer-actions">
                                <Button className="spgov-btn-secondary" onClick={closeBulkModal}>
                                    Cancel
                                </Button>

                                <Button
                                    className="spgov-btn-primary"
                                    onClick={handleExecuteBulkAction}
                                    disabled={
                                        bulkData.length === 0 ||
                                        isProcessingBulk ||
                                        isCheckingNames ||
                                        !bulkData.every((d) => d.class_id)
                                    }
                                >
                                    {isProcessingBulk
                                        ? "Processing..."
                                        : `Process ${bulkData.length} Records`}
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <Button className="spgov-btn-primary" onClick={closeBulkModal}>
                            Done
                        </Button>
                    )}
                </ModalFooter>
            </Modal>
            {selectedClass && (
                <Modal
                    isOpen={isEditModalOpen}
                    toggle={closeEditModal}
                    modalClassName="spgov-modal"
                >
                    <ModalHeader toggle={closeEditModal}>Edit Department Details</ModalHeader>

                    <ModalBody>
                        <div className="spgov-modal-section">
                            <div className="spgov-modal-section-title">
                                <Building2 size={16} />
                                Department Information
                            </div>

                            <div className="form-group">
                                <label>Department Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={updatedClassName}
                                    onChange={(e) => setUpdatedClassName(e.target.value)}
                                />
                            </div>

                            <div className="form-group mt-3">
                                <label>Official Group Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={editTingkatan}
                                    onChange={(e) => setEditTingkatan(e.target.value)}
                                />
                            </div>

                            <div className="form-group mt-3">
                                <label>Official Department Format</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={editClassMoeis}
                                    onChange={(e) => setEditClassMoeis(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="spgov-modal-section">
                            <div className="spgov-modal-section-title">
                                <Users size={16} />
                                Officer Access
                            </div>

                            <div className="form-check mb-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="allTeacherEnabled"
                                    checked={allTeacherEnabled === 1}
                                    onChange={(e) => setAllTeacherEnabled(e.target.checked ? 1 : 0)}
                                />
                                <label className="form-check-label fw-semibold" htmlFor="allTeacherEnabled">
                                    Enable this department for all officers
                                </label>
                            </div>

                            <div className="form-group">
                                <label>Assign Officers</label>
                                {isEditModalOpen && (
                                    <Select
                                        isMulti
                                        options={teachers}
                                        value={selectedTeachers}
                                        onChange={setSelectedTeachers}
                                        isDisabled={allTeacherEnabled === 1}
                                        styles={selectStyles}
                                    />
                                )}

                                {allTeacherEnabled === 1 && (
                                    <div className="spgov-modal-help">
                                        All officers are automatically enabled for this department.
                                    </div>
                                )}
                            </div>
                        </div>
                    </ModalBody>

                    <ModalFooter>
                        <div className="spgov-modal-footer-actions">
                            <Button className="spgov-btn-secondary" onClick={closeEditModal}>
                                Cancel
                            </Button>
                            <Button className="spgov-btn-primary" onClick={handleSaveChanges}>
                                Save Changes
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            )}
            <Modal
                isOpen={isAddModalOpen}
                toggle={closeAddModal}
                modalClassName="spgov-modal"
            >
                <ModalHeader toggle={closeAddModal}>Add New Department</ModalHeader>

                <ModalBody>
                    <div className="spgov-modal-section">
                        <div className="spgov-modal-section-title">
                            <Plus size={16} />
                            Department Setup
                        </div>

                        <div className="form-group">
                            <label>Department Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={newClassName}
                                onChange={(e) => setNewClassName(e.target.value)}
                                placeholder="Example: Finance Unit"
                            />
                        </div>

                        <div className="form-group mt-3">
                            <label>Department Group</label>
                            <Select
                                options={forms}
                                value={selectedForm}
                                onChange={setSelectedForm}
                                styles={selectStyles}
                                placeholder="Select department group"
                            />
                        </div>

                        <div className="form-group mt-3">
                            <label>Official Group Code</label>
                            <input
                                type="text"
                                className="form-control"
                                value={newTingkatan}
                                onChange={(e) => setNewTingkatan(e.target.value)}
                                placeholder="Official reference code"
                            />
                        </div>

                        <div className="form-group mt-3">
                            <label>Official Department Format</label>
                            <input
                                type="text"
                                className="form-control"
                                value={newClassMoeis}
                                onChange={(e) => setNewClassMoeis(e.target.value)}
                                placeholder="Official department format"
                            />
                        </div>
                    </div>
                </ModalBody>

                <ModalFooter>
                    <div className="spgov-modal-footer-actions">
                        <Button className="spgov-btn-secondary" onClick={closeAddModal}>
                            Cancel
                        </Button>
                        <Button className="spgov-btn-primary" onClick={handleAddClass}>
                            Add Department
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={isDeleteModalOpen}
                toggle={closeDeleteModal}
                modalClassName="spgov-modal"
            >
                <ModalHeader toggle={closeDeleteModal}>Confirm Delete</ModalHeader>

                <ModalBody>
                    <div className="spgov-delete-card">
                        This action will delete the department record:{" "}
                        <strong>{selectedClass?.class_name}</strong>.
                        <br />
                        Please confirm only if this department should no longer appear in the
                        administration portal.
                    </div>
                </ModalBody>

                <ModalFooter>
                    <div className="spgov-modal-footer-actions">
                        <Button className="spgov-btn-secondary" onClick={closeDeleteModal}>
                            Cancel
                        </Button>
                        <Button className="spgov-btn-danger" onClick={handleDeleteClass}>
                            Yes, Delete
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={isGuruKelasModalOpen}
                toggle={closeGuruKelasModal}
                modalClassName="spgov-modal"
            >
                <ModalHeader toggle={closeGuruKelasModal}>
                    Assign Department Lead
                </ModalHeader>

                <ModalBody>
                    <div className="spgov-modal-section">
                        <div className="spgov-modal-section-title">
                            <UserCheck size={16} />
                            {guruKelasClass?.class_name}
                        </div>

                        <div className="form-group">
                            <label>Select Officer</label>
                            <Select
                                options={teachers}
                                value={guruKelasOption}
                                onChange={setGuruKelasOption}
                                placeholder="Choose officer"
                                styles={selectStyles}
                            />
                        </div>

                        <div className="spgov-modal-help">
                            The selected officer will be shown as the department lead in the
                            department directory.
                        </div>
                    </div>
                </ModalBody>

                <ModalFooter>
                    <div className="spgov-modal-footer-actions">
                        <Button
                            className="spgov-btn-secondary"
                            onClick={closeGuruKelasModal}
                            disabled={guruKelasLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="spgov-btn-primary"
                            onClick={handleSetGuruKelas}
                            disabled={guruKelasLoading}
                        >
                            {guruKelasLoading ? "Saving..." : "Assign Lead"}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ClassesPage;